/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Status_Rejected8Inputs */

const en_application_status_rejected8 = /** @type {(inputs: Application_Status_Rejected8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

const de_application_status_rejected8 = /** @type {(inputs: Application_Status_Rejected8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Application_Status_Rejected8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const application_status_rejected8 = /** @type {((inputs?: Application_Status_Rejected8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Status_Rejected8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_status_rejected8(inputs)
	return en_application_status_rejected8(inputs)
});
export { application_status_rejected8 as "application_status_REJECTED" }